module.exports = __webpack_public_path__ + "assets/metrics-projects.ab6fce68.svg";